import '@fortawesome/fontawesome-svg-core/styles.css';
import '@monorepo/ui/styles/DOC/prism.css';

import { AlgoliaProvider } from '@monorepo/ui/algolia/provider';
import { DebugRecordingIndicatorGate, DevToolsShortcutGate } from '@monorepo/ui/components';
import { initDebugCapture, pushNavigation, setCurrentPageData } from '@monorepo/ui/services';

export * as global from '@monorepo/ui/styles/global.scss';

const config = require('@fortawesome/fontawesome-svg-core');
const { version } = require('../../package.json');

config.autoAddCss = false;

initDebugCapture();

export const wrapRootElement = ({ element }) => (
  <AlgoliaProvider>
    {element}
    <DebugRecordingIndicatorGate />
    <DevToolsShortcutGate />
  </AlgoliaProvider>
);

export const wrapPageElement = ({ element, props }) => {
  setCurrentPageData({ data: props.data, pageContext: props.pageContext, path: props.path });
  return element;
};

export const onRouteUpdate = ({ location }) => {
  console.info(`[scpo-ecoweb] v${version} — ${location.pathname}`);
  pushNavigation(location.pathname);
};

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  const currentPosition = getSavedScrollPosition(location);
  window.scrollTo(...(currentPosition || [0, 0]));
  return false;
};
